/**
 * Nile Premium — shared page header.
 * Deep-teal mesh accent card with gold overline + tight typography,
 * optional right-side actions and bottom stats strip.
 */
export default function PageHeader({
  overline, title, subtitle, actions, stats, badge, icon: Icon,
}) {
  return (
    <div
      className="relative rounded-2xl px-8 py-7 text-white"
      style={{
        background: "linear-gradient(135deg, #0E7469 0%, #0A5049 60%, #083E38 100%)",
      }}
    >
      {/* طبقة الخلفية الزخرفية وحدها لها overflow-hidden — عشان الدوائر
          الضبابية ما تخرجش عن حدود البطاقة، بدون التأثير على محتوى
          العنوان والأزرار (كان overflow-hidden على نفس حاوية المحتوى
          بيقصّ أي زر ما يلاقيش مكان يتلف له بدل ما ينزل لسطر جديد). */}
      <div className="absolute inset-0 rounded-2xl overflow-hidden pointer-events-none">
        <div
          className="absolute -top-24 -end-24 h-64 w-64 rounded-full opacity-40 blur-3xl"
          style={{ background: "#14B8A6" }}
        />
        <div
          className="absolute -bottom-24 -start-24 h-64 w-64 rounded-full opacity-25 blur-3xl"
          style={{ background: "#DAA520" }}
        />
        <div className="absolute inset-0 grid-fine opacity-100" />
      </div>

      <div className="relative flex items-start justify-between gap-6 flex-wrap">
        <div className="flex items-start gap-4 min-w-0">
          {Icon && (
            <div
              className="h-11 w-11 rounded-xl flex items-center justify-center shrink-0"
              style={{
                background: "rgba(255, 255, 255, 0.10)",
                border: "1px solid rgba(255, 255, 255, 0.16)",
                boxShadow: "0 6px 20px -4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <Icon className="h-5 w-5" style={{ color: "#F4D06F" }} strokeWidth={1.75} />
            </div>
          )}
          <div className="min-w-0">
            {overline && (
              <div className="flex items-center gap-2 mb-2">
                <span
                  className="text-[10.5px] font-bold uppercase tracking-[0.14em]"
                  style={{ color: "#F4D06F" }}
                >
                  {overline}
                </span>
                {badge && (
                  <span
                    className="text-[10.5px] font-semibold px-2 py-0.5 rounded-full"
                    style={{
                      background: "rgba(244, 208, 111, 0.14)",
                      border: "1px solid rgba(244, 208, 111, 0.28)",
                      color: "#F4D06F",
                    }}
                  >
                    {badge}
                  </span>
                )}
              </div>
            )}
            <h1 className="font-display text-[28px] font-bold tracking-tight leading-[1.1]">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-2 text-[13.5px] text-white/70 leading-relaxed max-w-2xl">
                {subtitle}
              </p>
            )}
          </div>
        </div>

        {actions && (
          <div className="flex items-center gap-2 flex-wrap shrink-0">
            {actions}
          </div>
        )}
      </div>

      {stats && stats.length > 0 && (
        <div className="relative mt-6 pt-6 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <div key={i}>
              <div className="text-[10.5px] font-medium text-white/50 tracking-wider mb-1.5">
                {s.label}
              </div>
              <div className="font-display text-[22px] font-bold tabular-nums flex items-baseline gap-1.5">
                <span>{s.value}</span>
                {s.suffix && <span className="text-[13px] text-white/50 font-normal">{s.suffix}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
